import { render, staticRenderFns } from "./PieChartTAP.vue?vue&type=template&id=1e3a85b5&scoped=true&lang=pug&"
import script from "./PieChartTAP.vue?vue&type=script&lang=ts&"
export * from "./PieChartTAP.vue?vue&type=script&lang=ts&"
import style0 from "./PieChartTAP.vue?vue&type=style&index=0&id=1e3a85b5&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3a85b5",
  null
  
)

export default component.exports